let apiBase = {
  login:'/api/adminUser/login',
  currentUser:'/api/adminUser/currentUser',
  loginOut:'/api/adminUser/loginOut',
}
let LoginSeverObject = null
class LoginSever{
  constructor(){}
  login(params={}){
	  return $http({
      method: 'post',
      url: apiBase.login,
      data:params
    })
   }
  currentUser(params={}){
	  return $http({
      url: apiBase.currentUser,
      method: 'get',
      params: params,
    })
  }
  loginOut(params={}){
	  return $http({
      url: apiBase.loginOut,
      method: 'get',
      params: params,
    })
  }
}
function singleLoginSever(){
  if(LoginSeverObject === null){
    LoginSeverObject = new LoginSever()
  }
  return LoginSeverObject
}
export default singleLoginSever()